import { getFeatureToggleClient } from '@taxfyle/web-commons/lib/misc/featureToggles'

export function isDisplayDocumentTagsToggleEnabled() {
  return getFeatureToggleClient().variation(
    'Portals.DisplayDocumentTags',
    false
  )
}
